'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paths = require('ifeis-isomorphic/lib/redux/actions/events/paths');

var _paths2 = require('ifeis-isomorphic/lib/redux/actions/feiseanna/paths');

var _paths3 = require('ifeis-isomorphic/lib/redux/actions/adjudicators/paths');

var loading = { loadingEvents: true };

var withAdjudicators = function withAdjudicators(state, events) {
  return events.map(function (ev) {
    if ((0, _paths.eventAdjudicatorsAreLoading)(state, ev.get('id'))) {
      return loading;
    }
    return ev.set('adjudicators', (0, _paths3.eventAdjudicators)(state, ev.get('id')));
  });
};

exports.default = function (feisId) {
  return function (state) {
    if ((0, _paths.eventsWithStatusAreLoading)(state, feisId, 'ADJ') || (0, _paths.eventsWithStatusAreLoading)(state, feisId, 'QA') || (0, _paths.eventsWithStatusAreLoading)(state, feisId, 'TABS') || (0, _paths2.feisAdjudicatorsAreLoading)(state, feisId)) {
      return loading;
    }

    var adjEvents = (0, _paths.eventsWithStatus)(state, feisId, 'ADJ');
    var qaEvents = (0, _paths.eventsWithStatus)(state, feisId, 'QA');
    var tabsEvents = (0, _paths.eventsWithStatus)(state, feisId, 'TABS');

    var adjudicators = (0, _paths3.adjudicatorsForFeis)(state, feisId);

    var eventsInAdjudication = withAdjudicators(state, adjEvents);

    if (eventsInAdjudication.some(function (l) {
      return l.loadingEvents;
    })) {
      return loading;
    }

    var eventsInQa = withAdjudicators(state, qaEvents);

    if (eventsInQa.some(function (l) {
      return l.loadingEvents;
    })) {
      return loading;
    }

    var eventsInTabulations = withAdjudicators(state, tabsEvents);

    if (eventsInTabulations.some(function (l) {
      return l.loadingEvents;
    })) {
      return loading;
    }

    return {
      adjEvents: eventsInAdjudication,
      qaEvents: eventsInQa,
      tabsEvents: eventsInTabulations,
      adjudicators: adjudicators
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/tabulations/mapStateToController.js
// module id = 580
// module chunks = 0